import {Controller} from "@hotwired/stimulus"

export default class extends Controller {

    static get targets() {
        return [
            "blob",
            "input",
            "preview",
        ]
    }

    connect() {
        this.onChange = this.onChange.bind(this)
        this.save = this.save.bind(this)
    }

    onChange() {
        const file = this.inputTargets
            .find(it => it.files && it.files[0])
            .files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = this.save;
            reader.readAsDataURL(file);
        }
    }

    save(event) {
        const blob = event.target.result;
        const parts = blob.split(',');

        this.blobTarget.value = parts[1];
        this.inputTarget.value = "";
        this.previewTarget.src = blob;
        this.previewTarget.classList.remove("membership-document-placeholder");

        event.preventDefault();
    }
}